import Button from "src/components/Button";
import { JobInterview } from "src/types";
import { ReactComponent as Check } from "src/assets/svg/check.svg";
import { ReactComponent as X } from "src/assets/svg/x6.svg";
import { useState } from "react";
import ShortlistModal from "src/pages/job/components/ShortlistModal";
import RejectModal from "src/pages/job/components/RejectModal";

interface ICompleteButtons {
  interview: JobInterview;
  onUpdate: (intv: JobInterview | undefined) => void;
}

// Buttons to mark an interview as rejected or passed, if aleady marked will show badges instead
const CompleteButtons = ({ interview, onUpdate }: ICompleteButtons) => {
  const { completed, passed, failed } = interview.Interview;

  const [approving, setApproving] = useState(false);
  const [rejecting, setRejecting] = useState(false);

  return (
    <>
      {completed && (
        <div className="flex gap-6">
          <Button
            onClick={() => setRejecting(true)}
            className="!w-[195px]"
            variant="light_red2"
            shapeVariant={2}
          >
            Reject Candidate
          </Button>

          <Button
            onClick={() => setApproving(true)}
            className="!w-[208px]"
            variant="green"
            shapeVariant={2}
          >
            Shortlist Candidate
          </Button>
        </div>
      )}
      {passed && (
        <div className="p-4 w-fit flex items-center gap-2 bg-[rgba(38,153,63,0.05)] rounded-lg text-base text-success font-semibold ">
          <Check className="shrink-0 fill-success w-6 h-6" /> Shortlisted
        </div>
      )}
      {failed && (
        <div className="p-4 w-fit flex items-center gap-2 bg-[rgba(211,47,47,0.05)] rounded-lg text-base text-red  border-[1px] border-red font-semibold ">
          <X className="shrink-0 w-6 h-6" /> Rejected
        </div>
      )}

      {/* Modals */}
      <ShortlistModal
        open={approving}
        setOpen={setApproving}
        interview={interview}
        onShortlist={onUpdate}
      />

      <RejectModal
        open={rejecting}
        setOpen={setRejecting}
        interview={interview}
        onReject={onUpdate}
      />
    </>
  );
};

export default CompleteButtons;
